/*

    Module: jv.common.linear-meter.directive
    Directive: jvLinearMeter

    Usage:

        <div jv-linear-meter steps="10" activeStep="{{ stepNum }}"></div>

    Arguments:
    - steps: total steps, must be a string and not an expressin for performance optimization
    - activeStep: integer of steps less than and equal to that will be highlighted

 */

angular.module('jv.common.linear-meter.directive', [])
.directive('jvLinearMeter', function() {
    return {
        scope: {
            steps: '@',
            activeStep: '@'
        },
        link: function(scope, element, attributes) {
            attributes.$observe('activeStep', function(val) {
                scope.activeStepInt = Math.round(Number(val));
            });
            scope.activeClass = function(step) {
                return (scope.activeStepInt > step) ? 'active' : '';
            };
        },
        template: function(element, attributes) {
            var steps = [];
            var maxSteps = Number(attributes.steps);
            for (var i = 0; i < maxSteps; i++) {
                steps.push('<div class="jv-linear-meter-step" ng-class="activeClass(' + i + ')"></div>');
            }
            return  '<div class="jv-linear-meter">' +
                        steps.join('') +
                    '</div>'
        }
    }
});